module.exports = __webpack_public_path__ + "img/view3d-notice-1-light.22318ed6.png";